// extracted by mini-css-extract-plugin
module.exports = {"badge":"styles-module__badge___2vw_c","badge-value":"styles-module__badge-value___1bS-e","empty-badge":"styles-module__empty-badge___2oJ0V"};